import React from "react";
import Section from "./Section";

export default function HTML_Comments() {
  return (
    <div className="tutorial-container">
      {/* 🔹 Title */}
      <h1 className="tutorial-title">💭 HTML Comments</h1>

      {/* 🔹 Introduction */}
      <p className="tutorial-intro">
        Comments in HTML are used to add notes, explanations, or reminders
        inside the code. They are <strong>not displayed</strong> in the browser
        output but help developers understand the structure or purpose of the
        code.
      </p>

      {/* 🔹 Info Box */}
      <div
        className="Key_point_container"
        style={{
          background: "linear-gradient(135deg, #f0f9ff, #e0f2fe)",
          borderRadius: "12px",
          padding: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        <h3
          style={{
            color: "#0284c7",
            fontWeight: 700,
            fontSize: "1.5rem",
            marginBottom: "0.5rem",
          }}
        >
          🧠 Syntax of HTML Comment
        </h3>
        <p>
          Comments are written between{" "}
          <code className="highlight_code_1">&lt;!--</code> and{" "}
          <code className="highlight_code_1">--&gt;</code>
          <br />
          Anything inside this will be ignored by the browser.
        </p>
      </div>

      {/* Section 1️⃣ — Basic Comment Example */}
      <Section
        title="1️⃣ Basic HTML Comment"
        html={`<!-- This is a single-line HTML comment -->
<p>This is a visible paragraph.</p>`}
        description="A simple comment that is ignored by the browser but can help describe your code for yourself or others."
      />

      {/* Section 2️⃣ — Comment Inside HTML Elements */}
      <Section
        title="2️⃣ Comment Inside HTML Structure"
        html={`<h2>My Favorite Fruits</h2>
<ul>
  <li>Apple</li>
  <!-- Banana is not in the list today -->
  <li>Mango</li>
  <li>Orange</li>
</ul>`}
        description="Comments can be used inside lists, divs, or anywhere in the HTML document to hide or explain parts of the structure."
      />

      {/* Section 3️⃣ — Multi-line Comment */}
      <Section
        title="3️⃣ Multi-line Comment"
        html={`<!--
This is a multi-line comment.
It can span across several lines.
It is useful for long notes or temporarily disabling code.
-->
<p>HTML comments can be very useful during development!</p>`}
        description="Multi-line comments are useful for writing notes, documentation, or temporarily hiding parts of your HTML code."
      />

      {/* Section 4️⃣ — Hide Elements Temporarily */}
      <Section
        title="4️⃣ Temporarily Hide Elements"
        html={`<!-- <p>This paragraph is hidden and will not appear on the webpage.</p> -->
<p>This paragraph is visible.</p>`}
        description="You can use comments to temporarily disable parts of your code without deleting them. This helps during debugging or testing."
      />

      {/* ✅ Summary Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde68a)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>📘 Summary — HTML Comments</h2>
        <ul className="tutorial-list-points">
          <li>
            Write comments between <code>&lt;!--</code> and <code>--&gt;</code>
          </li>
          <li>Comments are ignored by browsers.</li>
          <li>They are useful for documentation and debugging.</li>
          <li>
            You can use comments to hide parts of the code temporarily instead
            of deleting them.
          </li>
          <li>Comments make your code more readable and organized.</li>
        </ul>
      </div>
    </div>
  );
}
